/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { unmockUser } from 'state/thunks/session';
// material
import { Button } from '@insticator/insticator-ui';
import { ReactComponent as ArrowBack } from 'assets/icons/arrow-back.svg'
// utils
import { redirectToPubPortalClassic } from '../../../../utils/redirecttopubportalclassic';
// styles
import injectSheet from 'react-jss';
import styles from './switch_styles';



/* ========== ~~~~~~~~~~ SWITCH ~~~~~~~~~~ ========== */
const Switch = injectSheet(styles)((props) => {
  const sidebarOpen = useSelector((state) => state.app.sidebarOpen);
  const { mocked } = useSelector((state) => state.session);
  const dispatch = useDispatch()

  // feature flag
  const showBackToClassButton = useSelector((state) => state.account.showNewRevenueMetrics);
  // return null; //if showBackToClassButton is false and user is client(not admin) , then don't show back to classic button

  //if showBackToClassButton is true OR user is admin, then show classic button to them to go back to publisher portal classic
  // if not mocked do not show 
  if(!mocked) return null

  const redirectToAdminPanel = () => dispatch(unmockUser())
  
  return (
    <div id='sidebar-switch' className={`${props.classes.switch} sidebarOpen-${sidebarOpen}`}>
      <div id='sidebar-switch-inner'>
        <div className={`desc`}>
          <p>You're using Publisher Portal 2.0</p>
        </div>
        <Button
          name={'calltoaction'}
          type={'custom'}
          variant={'primary'}
          text={<span><ArrowBack /> Switch back to admin panel</span>}
          handleClick={redirectToAdminPanel}
        />
      </div>
    </div>
  );
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Switch;
